import React, { useEffect, useState, useCallback } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

export default function Documents() {
    const [data, setData] = useState([]);

    const fetchDetails = useCallback(async () => {
        try {
            const response = await fetch(`/api/getDocuments`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({}),
            });

            if (response.ok) {
                const Data = await response.json();
                setData(Data);
            } else {
                console.error("Error fetching filtered data");
            }
        } catch (error) {
            console.error("Error fetching filtered data:", error);
        }
    }, []);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    useEffect(() => {
        AOS.init({
          duration: 900,
          easing: "ease-out-cubic",
          once: true,
          offset: 80,
        });
    }, []);
    
    return (
        <>
            <section className="bg-gradient-to-r from-blue-950 to-blue-900 py-24 text-white">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <h1 className="text-4xl md:text-5xl font-extrabold tracking-wide" data-aos="fade-down">
                        School Documents
                    </h1>
                    <p className="mt-3 text-green-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
                        Important notices, circulars, and downloadable resources
                    </p>
                </div>
            </section>

            <section className="max-w-6xl mx-auto px-4 py-16">
                <div className="text-center mb-10">
                    <h2 className="text-3xl font-bold text-gray-900" data-aos="fade-up">
                        Access class-wise official PDFs and school communications
                    </h2>
                    <div className="w-24 h-1 bg-[#F4B400] mx-auto mt-4 rounded-full" data-aos="zoom-in" data-aos-delay="150"></div>
                </div>

                <div className="overflow-x-auto" data-aos="fade-up" data-aos-delay="250">
                    <div className="grid grid-cols-3 min-w-[700px] rounded-xl overflow-hidden shadow-lg">

                        <div className="bg-gradient-to-r from-blue-950 to-blue-700 text-white font-semibold p-4 text-center" data-aos="fade-down">
                            Class
                        </div>
                        <div className="bg-blue-100 text-gray-900 font-semibold p-4 text-center" data-aos="fade-down" data-aos-delay="100">
                            Title
                        </div>
                        <div className="bg-blue-100 text-gray-900 font-semibold p-4 text-center" data-aos="fade-down" data-aos-delay="200">
                            Documents
                        </div>

                        {data.map((item, index) => (
                            <>
                                <div className="bg-gradient-to-r from-blue-950 to-blue-700 text-white p-4 font-medium text-center" data-aos="fade-up" data-aos-delay="100">
                                    {item.ClassName}
                                </div>
                                <div className="bg-white p-4 text-center text-gray-700" data-aos="fade-up" data-aos-delay="150">
                                    {item.Title}
                                </div>
                                <div className="bg-white p-4 text-center text-gray-700" data-aos="fade-up" data-aos-delay="200">
                                    <a href={`/Documents/${item.PDF}`} target="_blank" rel="noopener noreferrer"><i className='bi bi-file-pdf-fill fs-6'></i></a>
                                </div>
                            </>
                        ))}



                    </div>
                </div>
            </section>
        </>
    );
}


